import { InjectionToken, inject, DOCUMENT } from '@angular/core';

export const WINDOW = new InjectionToken<Document['defaultView']>('WINDOW', {
  factory: () => inject(DOCUMENT).defaultView,
});

export const NAVIGATOR = new InjectionToken<Navigator | null>('NAVIGATOR', {
  factory: () => inject(WINDOW)?.navigator ?? null,
});
